import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGet } from '../../../hooks/useApi';
import PayFees from '../steps/PayFees';

interface RegisterData {
  data?: {
    total?: number;
    paymentIntent?:
      | {
          id?: string;
          client_secret?: string;
        }
      | string;
    metadata?: {
      requiresPayment?: boolean;
      isBilledToOrganization?: boolean;
    };
    studentId?: number;
    studentRegistrationWindowId?: number;
    studentsSchedules?: Array<{
      currentlySchedulingId?: string;
    }>;
  };
  isLoading: boolean;
  isError: boolean;
  error?: any;
}

interface PendingEnrollmentPaymentProps {
  onGoBack?: () => void;
  onCancel: () => void;
  isCanceling: boolean;
}

const PendingEnrollmentPayment: React.FC<PendingEnrollmentPaymentProps> = ({
  onGoBack,
  onCancel,
  isCanceling,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const currentlySchedulingId = params.currentlySchedulingId;
  // The registration already exists, so "back" leaves checkout rather than
  // returning to the review step, which would register it again.
  const handleGoBack = onGoBack ?? (() => navigate('/scheduling'));

  // Fetch existing enrollment data
  const enrollmentData = useGet<any>(
    currentlySchedulingId
      ? `/v1/auth/reg/register-schedule/${currentlySchedulingId}`
      : null
  );

  // Transform enrollment data to match PayFees expected format
  const transformedRegisterData: RegisterData = {
    data: enrollmentData.data
      ? {
          total: enrollmentData.data.total,
          paymentIntent: enrollmentData.data.paymentIntent,
          metadata: enrollmentData.data.metadata,
          studentId: enrollmentData.data.studentRegistrationWindow?.studentId,
          studentRegistrationWindowId: enrollmentData.data.id,
          studentsSchedules: [
            {
              currentlySchedulingId: currentlySchedulingId,
            },
          ],
        }
      : undefined,
    isLoading: enrollmentData.isLoading,
    isError: enrollmentData.isError,
    error: enrollmentData.error,
  };

  if (enrollmentData.isLoading) {
    return <div>Loading enrollment data...</div>;
  }

  if (enrollmentData.isError || !enrollmentData.data) {
    return (
      <div>
        <p>Error loading enrollment data. Please try again.</p>
        <button onClick={handleGoBack}>Go Back</button>
      </div>
    );
  }

  return (
    <PayFees
      register={transformedRegisterData}
      onGoBack={handleGoBack}
      onCancel={onCancel}
      isCanceling={isCanceling}
    />
  );
};

export default PendingEnrollmentPayment;
